import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateEvent from './components/createEvent';
import EventCard from "./components/eventCard";

const API_URL = process.env.API_URL;

function EventPage() {
    const [activeMenu, setActiveMenu] = useState('all');
    const [createContainer, setCreateContainer] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (id) => {
        navigate(`/dashboard/invoice/${id}`);
    };

    return (
        <div className='pageContainer'>
            <h1>Events</h1>
            <div className="eventMenu">
                <p
                    className={activeMenu === 'all' ? 'eventActiveItem' : 'eventListItem'}
                    onClick={() => {
                        setActiveMenu('all');
                        setCreateContainer(false);
                    }}
                >
                    Alle Events
                </p>
                <p
                    className={activeMenu === 'new' ? 'eventActiveItem' : 'eventListItem'}
                    onClick={() => {
                        setActiveMenu('new');
                        setCreateContainer(true);
                    }}
                >
                    Neues Event
                </p>
            </div>

            {createContainer && activeMenu === 'new' && <CreateEvent />}

            {activeMenu === 'all' && (
                <div className="eventCardContainer">
                    <EventCard />
                </div>
            )}
        </div>
    );
}

export default EventPage;